import React, { useState } from "react"
import formStyles from "./formStyles.module.css"
import { Formik, Form, Field, ErrorMessage } from "formik"

import BtnSubmitMobile from "../images/bg-btn-submit-mobile.png"
import BtnSubmitDesktop from "../images/bg-btn-submit-desktop.png"

import ImgSuccesMobile from "../images/img-succes-mobile.png"
import ImgSuccesDesktop from "../images/img-succes-desktop.png"

import ImgSendingMobile from "../images/img-sending-mobile.png"
import ImgSendingDesktop from "../images/img-sending-desktop.png"

const Basic = () => {
  const [formSentOk, setFormSentOk] = useState(false)
  const [serverError, setServerError] = useState(false)

  function postData(url = "", data = {}) {
    // Default options are marked with *
    return fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    }).then(response => response.json()) // parses JSON response into native JavaScript objects
  }

  return (
    <Formik
      initialValues={{
        magazin: "Alege magazinul",
        numarBon: "",
        nume: "",
        telefon: "",
        email: "",
      }}
      validate={values => {
        let errors = {}

        if (!values.magazin || values.magazin === "Alege magazinul") {
          errors.magazin = "Selectați un magazin"
        }

        if (!values.numarBon || values.numarBon === "") {
          errors.numarBon = "Introduceți numărul bonului"
        }

        if (!values.nume || values.nume === "") {
          errors.nume = "Introduceți numele"
        }

        if (!values.telefon || values.telefon === "") {
          errors.telefon = "Introduceți un număr de telefon"
        }

        if (!values.email) {
          errors.email = "Introduceți adresa de email"
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
          errors.email = "Adresă de email incorectă"
        }
        return errors
      }}
      onSubmit={(values, { setSubmitting }) => {
        postData(`${process.env.GATSBY_API_URL}`, values)
          .then(data => {
            setSubmitting(false)
            setFormSentOk(true)
            setServerError(false)
          }) // JSON-string from `response.json()` call
          .catch(error => {
            console.error(error)
            setSubmitting(false)
            setServerError(true)
          })
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className={formStyles.formGrid}>
            <div>
              <label className={formStyles.label} htmlFor="magazin">
                Unde ai făcut cumpărăturile:
              </label>
              <div className={formStyles.inputWrp01}>
                <Field component="select" name="magazin" id="magazin">
                  <option value="alege magazinul">Alege magazinul</option>
                  <option value="Prima Market Brătianu">
                    Prima Market Brătianu
                  </option>
                  <option value="Prima Market Sf. Vineri">
                    Prima Market Sf. Vineri
                  </option>
                  <option value="Prima Supermarket">Prima Supermarket</option>
                  <option value="Prima Non-Stop">Prima Non-Stop</option>
                  <option value="Prima Discount">Prima Discount</option>
                  <option value="Prima Market Priboieni">
                    Prima Market Priboieni
                  </option>
                  <option value="Prima Market Bogați">
                    Prima Market Bogați
                  </option>
                </Field>
              </div>
            </div>
            <div>
              <label className={formStyles.label} htmlFor="numarBon">
                Numărul bonului de cumpărături:
              </label>
              <div className={formStyles.inputWrp02}>
                <Field
                  type="text"
                  name="numarBon"
                  id="numarBon"
                  placeholder="xxx"
                />
              </div>
            </div>

            <div className={formStyles.gridItemSpanTwo}>
              <label className={formStyles.label} htmlFor="nume">
                Numele tău:
              </label>
              <div className={formStyles.inputWrp03}>
                <Field type="text" name="nume" id="nume" placeholder="xxx" />
              </div>
            </div>
            <div>
              <label className={formStyles.label} htmlFor="telefon">
                Telefon:
              </label>
              <div className={formStyles.inputWrp04}>
                <Field
                  type="text"
                  name="telefon"
                  id="telefon"
                  placeholder="xxx"
                />
              </div>
            </div>
            <div>
              <label className={formStyles.label} htmlFor="email">
                Email:
              </label>
              <div className={formStyles.inputWrp05}>
                <Field type="text" name="email" id="email" placeholder="xxx" />
              </div>
            </div>
            <div
              className={formStyles.gridItemSpanTwo + " " + formStyles.errorWrp}
            >
              <ErrorMessage
                className={formStyles.errorMessage}
                name="magazin"
                component="div"
              />
              <ErrorMessage
                className={formStyles.errorMessage}
                name="numarBon"
                component="div"
              />
              <ErrorMessage
                className={formStyles.errorMessage}
                name="nume"
                component="div"
              />
              <ErrorMessage
                className={formStyles.errorMessage}
                name="telefon"
                component="div"
              />
              <ErrorMessage
                className={formStyles.errorMessage}
                name="email"
                component="div"
              />
            </div>
          </div>

          <div className={formStyles.formFooterGrid}>
            <div className={formStyles.formFooterGridEl01}>
              {!isSubmitting && !formSentOk && (
                <button
                  className={formStyles.formBtnSubmit}
                  type="submit"
                  disabled={isSubmitting}
                >
                  <img
                    className={formStyles.showImgMobile}
                    src={BtnSubmitMobile}
                    height="60"
                    width="291"
                    alt=""
                  />
                  <img
                    className={formStyles.showImgDesktop}
                    src={BtnSubmitDesktop}
                    height="49"
                    width="186"
                    alt=""
                  />
                </button>
              )}
              {formSentOk && (
                <div className={formStyles.successMsg}>
                  Bonul tău a fost înregistrat!
                </div>
              )}
              {serverError && (
                <div className={formStyles.successMsg}>Eroare de server.</div>
              )}
              {isSubmitting && (
                <div>
                  <img
                    className={formStyles.showImgMobile}
                    src={ImgSendingMobile}
                    height="60"
                    width="291"
                    alt=""
                  />
                  <img
                    className={formStyles.showImgDesktop}
                    src={ImgSendingDesktop}
                    height="49"
                    width="186"
                    alt=""
                  />
                </div>
              )}
            </div>
            <div className={formStyles.formFooterGridEl02}>
              <img
                className={
                  formStyles.showImgMobile + " " + formStyles.successImg
                }
                src={ImgSuccesMobile}
                width="236"
                height="35"
                alt=""
              />
              <img
                className={
                  formStyles.showImgDesktop + " " + formStyles.successImg
                }
                src={ImgSuccesDesktop}
                width="163"
                height="27"
                alt=""
              />
            </div>
            <div className={formStyles.formFooterGridEl03}>
              <span className={formStyles.regulament}>
                Citește regulamentul complet al concursului{"\u00A0"}
                <a
                  className={formStyles.highlightedAnchor}
                  href="http://primamarket.ro/PrimaMarket-RegulamentConcursStonebird.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  aici.
                </a>
              </span>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default Basic
